<template>
  <div>
    <h3 class="blue-grey--text text--lighten-1">{{ item.question }}</h3>
    <span style="font-size: 15px;">{{ item.answer }}</span>
  </div>
</template>

<script>
  export default {
    name: 'QuestionItem',

    props: {
      item: { type: Object }
    }
  }
</script>

<style lang="scss" scoped>

</style>